import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SharedLanguage = _resolveComponent("SharedLanguage")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createVNode(_component_router_link, {
      class: _normalizeClass(_ctx.b('logo')),
      to: "/landing"
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", { innerHTML: _ctx.displayedLogo }, null, 8, _hoisted_1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_SharedLanguage, { view: "main" })
  ], 2))
}